import lottie from 'lottie-web';
import animationData from "../../assets/lottiefiles/loader.lottie.json";
import {AllInBox} from "../AllInBox";
import toastr from "toastr";

export class LivewireListeners {
    static init() {
        this.listeners();
    }

    static listeners() {
        // noinspection JSUnresolvedVariable
        Livewire.hook('message.processed', (message, component) => {
            AllInBox.init();
        });

        // noinspection JSUnresolvedVariable
        Livewire.hook('message.sent', (message, component) => {
            let elements = document.querySelectorAll('.livewire-loading-loader');
            elements.forEach((element) => {
                element.innerHTML = '';

                lottie.loadAnimation({
                    container: element,
                    loop: true,
                    autoplay: true,
                    animationData,
                    rendererSettings: {
                        preserveAspectRatio: "xMidYMid slice",
                        className: "lottie-svg-class",
                    }
                });
            });
        });

        window.livewire.on('wireFlash', (level, message, title = '') => {
            switch (level) {
                case 'success':
                    toastr.success(message, title);
                    break;
                case 'error':
                    toastr.error(message, title);
                    break;
                case 'info':
                    toastr.info(message, title);
                    break;
                case 'warning':
                    toastr.warning(message, title);
                    break;
            }
        });
    }
}